import React from "react";

export interface ListPageToolbarProps {
  /** Search bar and actions. */
  children: React.ReactNode;
  /**
   * Layout of the row (flex direction, alignment, widths) — never spacing.
   * Defaults to a single row: search on the left, actions on the right.
   */
  className?: string;
  /** Content under the row but still inside the toolbar's bottom spacing (e.g. phone tabs). */
  footer?: React.ReactNode;
}

const DEFAULT_ROW_LAYOUT = "flex items-center justify-between gap-3";

/**
 * Search/actions strip above a list table. One source of truth for the list
 * spacing (CTX-1614): the margins live here and views only choose the row layout.
 * Desktop: no margin above the row (the card body supplies it) and 12px between
 * the row and the table. Mobile keeps its compact 8px steps.
 */
export const ListPageToolbar: React.FC<ListPageToolbarProps> = ({
  children,
  className = DEFAULT_ROW_LAYOUT,
  footer,
}) => {
  return (
    <div className="mb-2 sm:mb-3 bg-[var(--semantic-bg-primary)] flex-shrink-0">
      <div className={`${className} mt-0 mb-2 sm:mb-0`}>{children}</div>
      {footer}
    </div>
  );
};

export default ListPageToolbar;
